import { FC, useEffect, useState } from "react";
import styles from "./AdminPanel.module.scss";
import { TClaim, TClaimChange } from "../../types/claim";
import { ErrorPage } from "../../pages/ErrorPage/ErrorPage";
import { changeClaims, getClaims } from "../../api/claim";
import check from "../../images/icons/check.svg";
import notCheck from "../../images/icons/close.svg";

export const AdminClaim: FC<{
  type: "nicht berücksichtigt" | "abgelehnt" | "angenommen";
}> = ({ type }) => {
  const [claim, setClaim] = useState<TClaim[]>([]);
  const [claimAccep, setClaimAccep] = useState<TClaim[]>([]);
  const [claimDen, setClaimDen] = useState<TClaim[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    try {
      setIsLoading(true);
      const data: TClaim[] = await getClaims();
      setClaim(data.filter((item) => item.accept === "not_considered"));
      setClaimAccep(data.filter((item) => item.accept === "accepted"));
      setClaimDen(data.filter((item) => item.accept === "denied"));
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function handlerAccepted(idClaim: number) {
    try {
      setIsLoading(true);
      const claim: TClaimChange = {
        id: idClaim,
        accept: "accepted",
      };
      await changeClaims(claim);
      fetchData();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function handlerDenied(idClaim: number) {
    try {
      setIsLoading(true);
      const claim: TClaimChange = {
        id: idClaim,
        accept: "denied",
      };
      await changeClaims(claim);
      fetchData();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className={styles.container}>
      {type === "nicht berücksichtigt" &&
        claim &&
        claim.length > 0 &&
        claim.map((claim) => (
          <li className={styles.model} key={claim.id}>
            {claim.user.profileAvatar ? (
              <img
                className={styles.model_image}
                src={claim.user.profileAvatar.avatarUrl}
                alt="Photo"
              />
            ) : (
              <div className={styles.photo__placeholder}></div>
            )}
            <p className={styles.model_text}>
              {claim.user.firstName + " " + claim.user.lastName}
            </p>
            <p className={styles.model_text}>{claim.comment.comment}</p>

            <div>
              <img
                src={check}
                alt="IConVer"
                className={styles.icon}
                onClick={() => handlerAccepted(claim.id)}
              />
              <img
                src={notCheck}
                alt="IConNotVer"
                className={styles.icon}
                onClick={() => handlerDenied(claim.id)}
              />
            </div>
          </li>
        ))}
      {type === "abgelehnt" &&
        claimAccep &&
        claimAccep.length > 0 &&
        claimAccep.map((claim) => (
          <li className={styles.model} key={claim.id}>
            {claim.user.profileAvatar ? (
              <img
                className={styles.model_image}
                src={claim.user.profileAvatar.avatarUrl}
                alt="Photo"
              />
            ) : (
              <div className={styles.photo__placeholder}></div>
            )}
            <p className={styles.model_text}>
              {claim.user.firstName + " " + claim.user.lastName}
            </p>
            <p className={styles.model_text}>{claim.comment.comment}</p>

            <div>
              <img
                src={notCheck}
                alt="IConNotVer"
                className={styles.icon}
                onClick={() => handlerDenied(claim.id)}
              />
            </div>
          </li>
        ))}
      {type === "angenommen" &&
        claimDen &&
        claimDen.length > 0 &&
        claimDen.map((claim) => (
          <li className={styles.model} key={claim.id}>
            {claim.user.profileAvatar ? (
              <img
                className={styles.model_image}
                src={claim.user.profileAvatar.avatarUrl}
                alt="Photo"
              />
            ) : (
              <div className={styles.photo__placeholder}></div>
            )}
            <p className={styles.model_text}>
              {claim.user.firstName + " " + claim.user.lastName}
            </p>
            <p className={styles.model_text}>{claim.comment.comment}</p>

            <div>
              <img
                src={check}
                alt="IConVer"
                className={styles.icon}
                onClick={() => handlerAccepted(claim.id)}
              />
            </div>
          </li>
        ))}
      {claim.length === 0 ||
        claimAccep.length === 0 ||
        (claimDen.length === 0 && <p>Die Liste ist leer</p>)}
    </div>
  );
};
